// DashboardLayout.jsx'in (server sahibi paneli) bağımsız kopyası — aynı
// app-shell/sidebar/topbar CSS sınıflarıyla, yayıncı auth'una bağlı.
import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { clearPublisherToken } from '../../api/publisherClient';
import Logo from '../../components/Logo';
import LanguageToggle from '../../components/LanguageToggle';
import ThemeToggle from '../../components/ThemeToggle';
import Icon from '../../components/Icon';

const LINKS = [
  { to: '/yayinci/panel', label: 'publisher.nav_panel', icon: 'grid', end: true },
];

export default function PublisherDashboardLayout({ title, subtitle, publisher, heading = true, children }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const doLogout = () => {
    clearPublisherToken();
    navigate('/yayinci/giris', { replace: true });
  };

  const initial = (publisher?.displayName || publisher?.email || '?').trim().charAt(0).toUpperCase();

  return (
    <div className="app-shell">
      {menuOpen && <div className="scrim" onClick={() => setMenuOpen(false)} />}
      <aside className={`sidebar ${menuOpen ? 'open' : ''}`}>
        <Logo />
        <div className="nav-group-label">{t('publisher.nav_group')}</div>
        <nav onClick={() => setMenuOpen(false)}>
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `side-link ${isActive ? 'active' : ''}`}>
              <Icon name={l.icon} />
              {t(l.label)}
            </NavLink>
          ))}
        </nav>
        <div className="side-foot">
          <button className="side-link" style={{ width: '100%', background: 'transparent', border: 0, cursor: 'pointer' }} onClick={doLogout}>
            <Icon name="log-out" />
            {t('publisher.logout')}
          </button>
        </div>
      </aside>

      <div className="app-main">
        <div className="app-topbar">
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button className="menu-btn" onClick={() => setMenuOpen((v) => !v)} aria-label="menu">
              <Icon name="menu" size={18} />
            </button>
            <span className="crumb"><strong>{title}</strong></span>
          </div>
          <div className="topbar-right">
            <ThemeToggle />
            <LanguageToggle />
            <span className="avatar" title={publisher?.email}>{initial}</span>
            <button className="btn btn-ghost btn-sm" onClick={doLogout} title={t('publisher.logout')}>
              <Icon name="log-out" size={14} />
              <span className="logout-label">{t('publisher.logout')}</span>
            </button>
          </div>
        </div>

        <div className="app-body page-enter">
          {heading && title && <h1 className="page-title">{title}</h1>}
          {heading && subtitle && <p className="page-sub">{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>
  );
}
